const SILENT_WAV_SAMPLE_RATE = 11_025;
const SILENT_WAV_SAMPLE_COUNT = 2_757;
const SILENT_WAV_HEADER_BYTES = 44;
const SILENT_WAV_DATA_BYTES = SILENT_WAV_SAMPLE_COUNT * 2;

function writeAscii(bytes, offset, value) {
  for (let index = 0; index < value.length; index += 1) {
    bytes[offset + index] = value.charCodeAt(index);
  }
}

export function createSilentWavBytes() {
  const bytes = new Uint8Array(SILENT_WAV_HEADER_BYTES + SILENT_WAV_DATA_BYTES);
  const view = new DataView(bytes.buffer);
  writeAscii(bytes, 0, "RIFF");
  view.setUint32(4, bytes.length - 8, true);
  writeAscii(bytes, 8, "WAVE");
  writeAscii(bytes, 12, "fmt ");
  view.setUint32(16, 16, true);
  view.setUint16(20, 1, true);
  view.setUint16(22, 1, true);
  view.setUint32(24, SILENT_WAV_SAMPLE_RATE, true);
  view.setUint32(28, SILENT_WAV_SAMPLE_RATE * 2, true);
  view.setUint16(32, 2, true);
  view.setUint16(34, 16, true);
  writeAscii(bytes, 36, "data");
  view.setUint32(40, SILENT_WAV_DATA_BYTES, true);
  return bytes;
}

export function createSilentWavDataUri() {
  const bytes = createSilentWavBytes();
  return `data:audio/wav;base64,${btoa(String.fromCharCode(...bytes))}`;
}
